import { ApiResponse } from '@/types/api'
import {
  TArticle,
  TArticleParams,
  TBlogData,
  TBlogParams,
  TWordPressPost,
  TWordPressPostsParams,
} from '@/types/blog'
import { httpClient } from './http-client'

export class __cBlogService {
  static async getArticles(params: TArticleParams) {
    const response = await httpClient.V1.get<ApiResponse<TArticle[]>>(
      '/articles',
      {
        params,
      }
    )
    return response.data
  }

  static async getBlogs(params: TBlogParams) {
    const response = await httpClient.V1.get<TBlogData>('/blog/index', {
      params,
    })
    return response
  }

  static async getWordPressPosts(params: TWordPressPostsParams) {
    const response = await httpClient.DIRECT.get<TWordPressPost[]>(
      '/api/wordpress-posts',
      {
        params: {
          categories: params.categories,
          per_page: params.per_page || 10,
        },
      }
    )
    return response
  }
}
